class DiscountCode extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleAfterDiscountUpdate = this.handleAfterDiscountUpdate.bind(this)
    this.handleInputFocus = this.handleInputFocus.bind(this)
    this.handleRemoveClick = this.handleRemoveClick.bind(this)

    if (this?.els?.form?.exists) {
      this.listeners.add(this.els.form.element, 'submit', this.handleSubmit)
    }

    if (this?.els?.input?.exists) {
      this.listeners.add(
        this.els.input.element,
        'pointerdown',
        this.handleInputFocus,
      )
      this.listeners.add(
        this.els.input.element,
        'focus',
        this.handleInputFocus,
      )
    }

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_UPDATE_CART_DISCOUNT,
      this.handleAfterDiscountUpdate,
    )

    this.listeners.add(document, 'click', this.handleRemoveClick)
  }

  async handleSubmit (event) {
    event.preventDefault()

    if (this.getAttribute('aria-invalid') === 'true') return

    const formData = new FormData(event.target)
    const discountCode = formData.get('discount')

    const currentCodes = this.els.input.element.dataset.current || ''
    const discountCodes = currentCodes
      ? `${discountCode},${currentCodes}`
      : discountCode

    const state = await window.BAO.Cart.updateCartDiscount(discountCodes, {
      attemptedCode: discountCode,
    })

    if (state) {
      this.els.input.element.value = ''
    }
  }

  handleResponse (code) {
    this.ariaInvalid = !code.applicable

    if (code.applicable === true) {
      if (this?.els?.submit?.exists) {
        const textEl =
          this.els.submit.element.querySelector('.btn-Button_Text')

        if (textEl) {
          const appliedText = this.els.submit.element.dataset.applied
          const applyText = this.els.submit.element.dataset.apply

          textEl.textContent = appliedText
          textEl.dataset.text = appliedText

          this.els.submit.element.disabled = true

          setTimeout(() => {
            textEl.textContent = applyText
            textEl.dataset.text = applyText
            this.els.submit.element.disabled = false
          }, 2000)
        }
      }

      return
    }

    this.setErrorState()
  }

  handleAfterDiscountUpdate () {
    if (
      !this?.externalEls['accordion-trigger']?.exists ||
      !this?.externalEls['accordion-body']?.exists
    ) {
      return
    }

    this.externalEls['accordion-trigger'].element.setAttribute(
      'aria-expanded',
      'true',
    )
    requestAnimationFrame(() =>
      this.externalEls['accordion-trigger'].element.setAttribute(
        'aria-expanded',
        'true',
      ),
    )

    this.externalEls['accordion-body'].element.setAttribute(
      'aria-hidden',
      'false',
    )
    requestAnimationFrame(() =>
      this.externalEls['accordion-body'].element.setAttribute(
        'aria-hidden',
        'false',
      ),
    )
  }

  handleInputFocus () {
    if (this.getAttribute('aria-invalid') !== 'true') return

    this.els.input.element.placeholder =
      this.els.input.element.dataset.defaultPlaceholder

    this.ariaInvalid = false

    if (this?.els?.submit?.exists) {
      this.els.submit.element.disabled = false
    }
  }

  setErrorState () {
    if (!this?.els?.input?.exists) return

    this.els.input.element.value = ''
    this.els.input.element.placeholder =
      this.els.input.element.dataset.errorPlaceholder

    this.ariaInvalid = true

    if (this?.els?.submit?.exists) {
      this.els.submit.element.disabled = true
    }
  }

  async handleRemoveClick (event) {
    const removeEl = event.target.closest(
      '[data-discount-code-external-el="remove"]',
    )
    if (!removeEl) return

    event.preventDefault()

    const codeToRemove = removeEl.dataset.code.trim()
    if (!codeToRemove) return

    const currentCodes = (this.els?.input?.element?.dataset?.current || '')
      .split(',')
      .map((code) => code.trim())
      .filter((code) => code.length > 0)

    const nextCodes = currentCodes.filter(
      (currentCode) => currentCode.toLowerCase() !== codeToRemove.toLowerCase(),
    )

    await window.BAO.Cart.updateCartDiscount(nextCodes.join(','), {
      suppressDiscountValidation: true,
    })
  }
}

if (!customElements.get('discount-code')) {
  customElements.define('discount-code', DiscountCode)
}
